/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseShipmentProvidersProvidersInner } from './GetConfig200ResponseShipmentProvidersProvidersInner';
import {
    GetConfig200ResponseShipmentProvidersProvidersInnerFromJSON,
    GetConfig200ResponseShipmentProvidersProvidersInnerFromJSONTyped,
    GetConfig200ResponseShipmentProvidersProvidersInnerToJSON,
    GetConfig200ResponseShipmentProvidersProvidersInnerToJSONTyped,
} from './GetConfig200ResponseShipmentProvidersProvidersInner';

/**
 * 
 * @export
 * @interface GetConfig200ResponseShipmentProviders
 */
export interface GetConfig200ResponseShipmentProviders {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseShipmentProviders
     */
    selected: string | null;
    /**
     * 
     * @type {Array<GetConfig200ResponseShipmentProvidersProvidersInner>}
     * @memberof GetConfig200ResponseShipmentProviders
     */
    providers: Array<GetConfig200ResponseShipmentProvidersProvidersInner>;
}

/**
 * Check if a given object implements the GetConfig200ResponseShipmentProviders interface.
 */
export function instanceOfGetConfig200ResponseShipmentProviders(value: object): value is GetConfig200ResponseShipmentProviders {
    if (!('selected' in value) || value['selected'] === undefined) return false;
    if (!('providers' in value) || value['providers'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseShipmentProvidersFromJSON(json: any): GetConfig200ResponseShipmentProviders {
    return GetConfig200ResponseShipmentProvidersFromJSONTyped(json, false);
}

export function GetConfig200ResponseShipmentProvidersFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseShipmentProviders {
    if (json == null) {
        return json;
    }
    return {
        
        'selected': json['selected'],
        'providers': ((json['providers'] as Array<any>).map(GetConfig200ResponseShipmentProvidersProvidersInnerFromJSON)),
    };
}

export function GetConfig200ResponseShipmentProvidersToJSON(json: any): GetConfig200ResponseShipmentProviders {
    return GetConfig200ResponseShipmentProvidersToJSONTyped(json, false);
}

export function GetConfig200ResponseShipmentProvidersToJSONTyped(value?: GetConfig200ResponseShipmentProviders | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selected': value['selected'],
        'providers': ((value['providers'] as Array<any>).map(GetConfig200ResponseShipmentProvidersProvidersInnerToJSON)),
    };
}

